export const maxColorsLimit = 10;
